import React from "react";
import "./BtnStyle.css"

export const ContactGetStartBtn = ({text, color, size, onClick}) => {
    const buttonStyle = `${color} ${size}`;
  return (
    <div>
        <button className={`myBtn ${buttonStyle}`}>{text}</button>
      </div>
  );
};


